import { IProvider } from "../../../core/modules/admin-modules/contract/contracts/models/contracts.model";

export class PatchProviderList {
  static readonly type = '[Provider] Patch Provider List';
  constructor(public payload: IProvider[]) {}
}